/* HH PDP buy-box display tweaks (7 Sep 2026). Loaded from sections/hh-sub-tiers.liquid.
   assets/hh-sub-tiers.js is over the API push-size limit, so instead of editing its
   render functions we rewrite the RENDERED text here (display only — never touches
   cart state or the add-to-cart handlers). Re-applied after every buy-box render via
   a debounced MutationObserver; all rewrites are idempotent so they can't loop. */
(function () {
  if (window.__hhPdpTweaks) return;
  window.__hhPdpTweaks = true;
  var HH = window.HH_TIERS || {};
  var root = document.querySelector('[data-hh-tiers]');
  function money(c) { return '$' + (c / 100).toFixed(2); }

  /* Free-gift block: "🎁 Free pack — SE Premium Black (X2235BK)" -> "SE Premium Black";
     "FREE — normally $9.99 · pick a size" -> "FREE <s>$9.99</s>". */
  function patchGift() {
    var b = document.querySelector('.hh-t-gpinfo b');
    if (b) {
      var name = b.textContent.replace(/^.*?free pack\s*[—–-]\s*/i, '').replace(/\s*\(.*?\)\s*$/, '').trim();
      if (name && b.textContent !== name) b.textContent = name;
    }
    var free = document.querySelector('.hh-t-gpfree');
    if (free && !free.querySelector('s')) {
      var m = (free.textContent || '').match(/\$[\d.]+/);
      free.innerHTML = 'FREE' + (m ? ' <s>' + m[0] + '</s>' : '');
    }
  }

  /* Frequency select: "(recommended)" -> "(Popular)" (display only; the default
     plan is still detected from the underlying Appstle plan name). */
  function patchFreq() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hh-freq] option'), function (o) {
      if (/recommended/i.test(o.textContent)) o.textContent = o.textContent.replace(/\(recommended\)/i, '(Popular)');
    });
  }

  /* Hint: drop the "Most tradies reorder..." sentence, keep the email/skip line. */
  function patchHint() {
    var h = document.querySelector('.hh-t-hint');
    if (h && /most tradies/i.test(h.textContent)) {
      h.textContent = h.textContent.replace(/^\s*most tradies[^.]*\.\s*/i, '').trim();
    }
  }

  /* Show the RRP cut-through on BOTH buy options (one-time + subscription), like the
     reference. RRP = HH_TIERS.rrp * current box count. */
  function patchTotals() {
    if (!HH.rrp) return;
    var countB = document.querySelector('[data-hh-count] b');
    var q = countB ? (parseInt(countB.textContent, 10) || 0) : 0;
    if (!q) return;
    var rrpStr = money(HH.rrp * q);
    var oneTot = document.querySelector('.hh-t-optbox[data-mode="one"] .hh-t-opttot');
    if (oneTot) {
      var s1 = oneTot.querySelector('s');
      if (!s1) {
        oneTot.innerHTML = '<s>' + rrpStr + '</s>' + oneTot.textContent.trim();
      } else if (s1.textContent !== rrpStr) {
        s1.textContent = rrpStr;
      }
    }
    var s2 = document.querySelector('.hh-t-optbox[data-mode="sub"] .hh-t-opttot s');
    if (s2 && s2.textContent !== rrpStr) s2.textContent = rrpStr;
  }

  /* Add a "STARTER" ribbon to the 4-box tier card (matches POPULAR/BEST VALUE/TRADE). */
  function patchRib() {
    var card = document.querySelector('.hh-tiers .hh-t-card[data-q="4"]');
    if (!card || card.querySelector('.hh-t-rib')) return;
    var rib = document.createElement('span');
    rib.className = 'hh-t-rib';
    rib.textContent = 'STARTER';
    var save = card.querySelector('.hh-t-save');
    if (save && save.nextSibling) card.insertBefore(rib, save.nextSibling);
    else card.insertBefore(rib, card.firstChild);
  }

  function patchAll() { patchGift(); patchFreq(); patchHint(); patchTotals(); patchRib(); }

  /* ---- Cart drawer (site-wide) ---- */
  var EC_TILES = [
    ['/collections/light-duty', 'Light duty', '//hygienehub.au/cdn/shop/files/bubble-pink-nitrile-gloves-100pcs-nitrile-glove-7156201.jpg?v=1778196312&width=220'],
    ['/collections/medium-duty', 'Medium duty', '//hygienehub.au/cdn/shop/files/x2245-maxprotect-nitrile-powder-free-examination-gloves-100pcs-nitrile-glove-9220733.png?v=1778196312&width=220'],
    ['/collections/heavy-duty', 'Heavy duty', '//hygienehub.au/cdn/shop/files/heavy-duty-diamond-textured-gloves-grip-x-nitrile-glove-7856855.png?v=1778196312&width=220']
  ];
  function enhanceDrawer(cd) {
    /* Move each one-time upgrade pill to be a full-width grid child of its cart row
       (the details cell is only ~11px wide, so it can't render a readable pill). */
    Array.prototype.forEach.call(cd.querySelectorAll('.hh-sub'), function (sub) {
      var item = sub.closest('.cart-item');
      if (item && sub.parentElement !== item) item.appendChild(sub);
    });
    /* Replace the empty-cart "Nitrile Gloves" collection card with duty tiles. */
    var col = cd.querySelector('.cart-drawer__collection');
    if (col && !col.querySelector('.hh-ec-duty')) {
      var html = '<div class="hh-ec-h">Shop by duty</div><div class="hh-ec-duty">';
      EC_TILES.forEach(function (t) {
        html += '<a class="hh-ec-tile" href="' + t[0] + '"><img src="' + t[2] + '" alt="' + t[1] + '" loading="lazy"><span>' + t[1] + '</span></a>';
      });
      col.innerHTML = html + '</div>';
    }
  }
  function initDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    enhanceDrawer(cd);
    var deb;
    new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(function () { enhanceDrawer(cd); }, 60); })
      .observe(cd, { childList: true, subtree: true });
  }

  /* 30-day money-back line: keep the green headline, drop the "something wrong..."
     tail, add an (i) button that expands the details. */
  function initMBG() {
    var ps = document.querySelectorAll('.product__column-sticky p.product__text.inline-richtext, .product__info-container p.product__text.inline-richtext');
    var p = Array.prototype.filter.call(ps, function (el) { return /money back guarantee/i.test(el.textContent || ''); })[0];
    if (!p || p.getAttribute('data-hh-mbg')) return;
    p.setAttribute('data-hh-mbg', '1');
    p.innerHTML = '🛡️ <strong>30-Day Money Back Guarantee</strong>' +
      '<span class="hh-mbg-wrap">' +
      '<button type="button" class="hh-mbg-i" aria-label="Money-back guarantee details" aria-expanded="false">' +
      '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="10" cy="10" r="8"/><path d="M10 9v4" stroke-linecap="round"/><circle cx="10" cy="6.4" r=".7" fill="currentColor" stroke="none"/></svg>' +
      '</button>' +
      '<span class="hh-mbg-pop" hidden><b>How it works.</b> Not the toughest gloves you’ve used? Contact us within 30 days of delivery for a full refund. Set &amp; Forget members get 50 days.</span>' +
      '</span>';
    var btn = p.querySelector('.hh-mbg-i');
    var pop = p.querySelector('.hh-mbg-pop');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (pop.hasAttribute('hidden')) { pop.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
      else { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('click', function (e) {
      if (!p.contains(e.target)) { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
    });
  }

  function boot() {
    initMBG();
    initDrawer();
    if (root) {
      patchAll();
      var deb;
      new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(patchAll, 60); })
        .observe(root, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
